import { render } from "./money.vue?vue&type=template&id=2de8beaf"
import script from "./money.vue?vue&type=script&lang=js"
export * from "./money.vue?vue&type=script&lang=js"

import exportComponent from "/home/victorio/Desktop/Projetos/vue-brazil-money/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__